module.exports = __webpack_public_path__ + "img/Indica.30f7c176.svg";